/**
 * ServiceContractTypePresenter
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { TeamPresenter } from '@app/modules/teams/team-presenter';
import { niceList } from '@shared/utils/strings';
import { Presenter } from '../../presenters/presenter';

export class ServiceContractTypePresenter extends Presenter {
    get teams() {
        return this._get('teams', () => this.get('teams.data', []).map(team => TeamPresenter.create(team)));
    }

    get teamNames() {
        return this._get('teamNames', () => {
            const teams: TeamPresenter[] = this.teams || [];

            if (teams.length > 2) {
                return niceList(
                    teams.slice(0, 3).map(team => team.description)
                ) + ` and ${teams.length - 3} others`;
            }

            return niceList(teams.map(team => team.description));
        });
    }

    get name() {
        return this.description;
    }

    get description() {
        return this.data.description;
    }

    get hourly_rate() {
        return this.data.hourly_rate;
    }

    get hourly_rate_ranges() {
        return this.data.hourly_rate_ranges;
    }

    get uses_actual_times_for_calculation() {
        return this.data.uses_actual_times_for_calculation;
    }
}
